const animate = (duration, step, finalize=()=>{}) => {
  const o = new Date().getTime() 
  let frame = 0

  const loop = () => {
      frame++
      if (frame % 2 == 1) {
      const n = new Date().getTime() - o

      if (n < duration) {
          step(n / duration);
          requestAnimationFrame(loop);
      } else {
          step(1)
          finalize()
      }
      } else {
          requestAnimationFrame(loop)
      }
  }

  loop();
};

const swing = step => {
  return t => {
      if (t < 0.5) {
          return step(Math.pow(t * 2, 2) / 2)
      } else {
          return step((1.0 -  Math.pow(1.0 - (t - 0.5) * 2, 2)) / 2 + 0.5)
      }
  }
};

class Carousel {
  constructor(el, {onChange, onPageChange}={}) {
    this.$ = el;
    this.$board = el.querySelector('.carousel-board');
    this._page = 0;
    this._onChange = onChange || function() {};
    this._onPageChange = onPageChange || function() {};

    this.layout();
    
    window.addEventListener('resize', () => this.layout());
  }

  layout() {
    this.width = this.$.clientWidth;

    this.$.style.position = 'relative';
    this.$.style.overflow = 'hidden';
    this.$board.style.display = 'flex';
    this.$board.style.width = `${this.width * this.$board.children.length}px`;
    Array.from(this.$board.children).forEach($ => $.style.flex = 1);
    this.render();
  }

  get page() {
    return this._page
  }

  get count() {
    return this.$board.children.length;
  }

  moveTo(page) {
    const fr = this._page;

    animate(750, swing(t => {
        this._page = fr + (page - fr) * t;
        this.onChange();
        this.render();
    }), () => {
      this.onPageChange();
    });
  }

  jumpTo(page) {
    this._page = +page;
    this.render();
    this.onChange();
    this.onPageChange();
  }

  scroll() {
    return this._page * this.width
  }

  render() {
    this.$board.style.transform = `translateX(${-this.scroll()}px)`;
  }

  onChange() {
    this.$.dispatchEvent(new Event('change'));
  }

  onPageChange() {
    this.$.dispatchEvent(new Event('pagechange'));
  }
}

class PostList {
  constructor($) {
    const $cards = Array.from($.querySelectorAll('.card'));
    const $more = $.querySelector('.more');
    let max = 6;

    $more.addEventListener('click', () => {
      max += 6;
      render();
    });

    const render = () => {
      if ($cards.length <= max) {
        $.classList.add('-all');
      }

      $cards.slice(0, max).forEach($ => {
        $.style.display = 'block';
      });
    }

    render();
  }
}

function smooth($) {
  $.addEventListener('click', ev => {
    ev.preventDefault();
    document.querySelector($.getAttribute('href')).scrollIntoView({behavior: 'smooth'});
  });
}

function site() {
  const $openMenu = document.getElementById('open-menu');
  const $closeMenu = document.getElementById('close-menu');
  const $openSearch = document.getElementById('open-search');
  const $closeSearch = document.getElementById('close-search');
  const $goTop = document.getElementById('gotop');
  
  $openMenu.addEventListener('click', () => {
    document.body.classList.add('-modal', '-menu');
  });

  $closeMenu.addEventListener('click', () => {
    document.body.classList.remove('-modal', '-menu');
  });

  $openSearch.addEventListener('click', () => {
    document.body.classList.add('-modal', '-search');
  });
  
  $closeSearch.addEventListener('click', () => {
    document.body.classList.remove('-modal', '-search');
  });

  smooth($goTop);

  const onScroll = ($ => { 
    let mReverse = false;

    return dy => {
      const y = window.pageYOffset;
      const reverse = y != 0 && dy < 0;

      if (reverse != mReverse) {
        if (reverse) {
          $.classList.add('-reverse');
        } else {
          $.classList.remove('-reverse');
        }
      }
      mReverse = reverse;
    };
  })($goTop);

  window.addEventListener('scroll', (l => {
    let my = window.pageYOffset;
    return () => {
      const y = window.pageYOffset;
      l(y - my);
      my = y;
    };
  })(onScroll));
}

function home() {
  const $dots = document.querySelectorAll('.js-carousel-dot');
  const $back = document.getElementById('carousel-back');
  const $next = document.getElementById('carousel-next');
  const $carousel = document.getElementById('carousel');
  const $slides = Array.from(document.querySelectorAll('.slide'));
  const $slideContents = Array.from(document.querySelectorAll('.slide .content'));
  const slideCategories = $slides.map($ => $.getAttribute('data-category'));
  const colors = (style => ['column', 'seminar', 'book', 'youtube'].reduce((m, k) => { m[k]=style.getPropertyValue(`--${k}-color`); return m; }, {}))(getComputedStyle(document.body));
  const ww = window.innerWidth;

  const carousel = new Carousel($carousel);

  const rotate = (() => {    
    let timeout = null;

    return (tm=5000) => {
      if (timeout) clearTimeout(timeout);
      
      timeout = setTimeout(() => {
        carousel.moveTo(Math.round(carousel.page+1) % carousel.count);
        rotate();
      }, tm);
    }
  })();

  $back.addEventListener('click', () => {
    carousel.moveTo((Math.round(carousel.page-1)+carousel.count) % carousel.count);
    rotate();
  });

  $next.addEventListener('click', () => {
    carousel.moveTo(Math.round(carousel.page+1) % carousel.count);
    rotate();
  });

  rotate();
  
  $carousel.addEventListener('pagechange', () => {
    $dots.forEach($ => $.classList.remove('-active'));
    $dots[carousel.page].classList.add('-active');
  });

  $dots[0].classList.add('-active');

  let _change = null;

  const reset = () => {
    if (_change) $carousel.removeEventListener('change', _change);

    if (ww >= 1024) {
      _change = () => {
        const s = Math.floor(carousel.page);
        const t = carousel.page - s;
        const tt = Math.min(t * 1.5, 1);
    
        for (let i=0; i < $slides.length; i++) {
          $slides[i].style.transform = `translateX(${(tt-t)*-carousel.width}px)`;
          $slideContents[i].style.boxShadow = `${40 + (tt-t)*carousel.width}px 40px 0 0 ${colors[slideCategories[i]]}`;
        }
      };
    }

    $carousel.addEventListener('change', _change);
  };

  window.addEventListener('resize', () => {
    for (let i=0; i < $slides.length; i++) {
      $slides[i].style.transform = null;
      $slideContents[i].style.boxShadow = null;
    }
    reset();
  });

  reset();

  const $posts = document.getElementById('posts');
  new PostList($posts);
}

function category() {
  const $posts = document.getElementById('posts');
  new PostList($posts);
}

site();
window.oyamana = {home, category};